import { Map as ImmutableMap } from 'immutable';
import { getRequiresReAuth } from '../operators/getters';
export const getFirstMessengerConnectionThatRequiresReAuth = messengerConnections => {
  if (!ImmutableMap.isMap(messengerConnections)) return null;
  return messengerConnections.find(getRequiresReAuth);
};